import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';
import { isUddAutoApproveRemovedReason } from '../../../config/udd-removed-reasons';

export const reviewPotentialUndisclosedDriver: TaskDefinition = {
  taskName: onboardingTasks.ReviewPotentialUndisclosedDriver,
  config: {
    staffDisplayName: 'Review Potential Undisclosed Driver',
    appcuesModalId: 'f5065e3e-ca48-41d4-82b1-1d900b0f2b37',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 40,
    enabled: true,
    // Auto-approve only when the member selected a no-review-required reason
    // (CONFIRMED_DRIVER / DECEASED / UNKNOWN / PRIOR_OWNER / DUPLICATE).
    autoApprove: (taskData) => isUddAutoApproveRemovedReason(taskData?.removedReason),
    eventName: 'Review Potential Driver',
    account: {
      content: ({ data }) => {
        const driverName = data.driver ? `${data.driver.firstName || ''} ${data.driver.lastName || ''}`.trim() : '';
        return {
          title: `Review potential driver: ${driverName}`,
          incompleteSubtitle: `We've identified ${driverName} as a potential driver on your auto policy. Answer a few questions to ensure you have the right coverage for the correct household members.`,
          completedSubtitle:
            "You've completed your review of this potential driver. If you've submitted documents for review or we've determined this driver needs to be added, we will contact you via email.",
          actionLabel: 'Review driver',
          contentSections: [
            {
              title: 'Who should be on my auto policy?',
              body: 'Anyone who drives a vehicle regularly or who has access to it should be listed on the auto policy. This includes the vehicle owner as well as any family members who live in the same household and drive the vehicle. Accidents involving unlisted drivers may not be covered.'
            },
            {
              title: 'How much time do I have to review?',
              body: "Submit your review anytime before the policy's renewal effective date. However, once the renewal is generated (approximately 40–45 days prior to the effective date), the individual will be added as a driver if we have not received your review. If we receive your review after that, we can remove them if the review is approved."
            },
            {
              title: "What happens if I don't review?",
              body: "If we don't receive your review of this person's eligibility as a driver, we'll add them to your renewal policy to ensure you have the proper coverage. This will affect your premium."
            }
          ]
        };
      }
    }
  }
};
